import React, { useCallback } from "react";
import { toaster } from "evergreen-ui";
import PromiseButton from "../PromiseButton";
import useControlHub from "../../hooks/useControlHub";
import { APP_URL } from "../../config";

const InvoiceDeleteButton = ({ invoiceID, ...props }) => {
  const { api } = useControlHub();

  const deletePromise = useCallback(() => {
    return new Promise((resolve, reject) => {
      api
        .deleteBill({ billID: invoiceID })
        .then((data) => {
          if (!data.success) {
            throw new Error(
              "Invoice couldn't be deleted: " + (data.message || "-")
            );
          }
          toaster.success("Invoice has been set to deleted");
          resolve();
          setTimeout(() => {
            window.location.href = `${APP_URL}/ap/bills`;
          }, 1000);
        })
        .catch((error) => {
          toaster.danger(error.message);
          reject();
        });
    });
  }, [api, invoiceID]);

  return <PromiseButton {...props} promiser={deletePromise} />;
};

export default InvoiceDeleteButton;
